<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory, isCancelled } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    this.geocoder = null;
    this.timer = null;
    this.requestId = 0;
    this.destroyed = false;

    GeocoderFactory().then(geocoder => {
      if (!this.destroyed) {
        this.geocoder = geocoder;
      }
    });
  },

  beforeDestroy() {
    this.destroyed = true;
    this.cancelPending();
  },

  watch: {
    search(val) {
      if (!val || !val.trim()) {
        this.cancelPending();
        this.items = [];
        return;
      }

      if (this.select && val === this.select.text) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    cancelPending() {
      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.requestId++;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.cancelPending();

      if (!this.geocoder) {
        return;
      }

      const id = this.requestId;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoder.autocomplete(value).then(items => {
          if (id === this.requestId) {
            this.items = items.slice();
          }
        }).catch(err => {
          if (id === this.requestId && !isCancelled(err)) {
            this.items = [];
          }
        }).finally(() => {
          if (id === this.requestId) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.cancelPending();
      this.$emit("change", o);
    }
  }
};
</script>
